/*
 * Site footer — the link groups are a plain expanded list on desktop and a
 * disclosure accordion on mobile, matching the two Figma frames.
 *
 * The markup ships with `open` so the links are always readable without JS.
 * Below the mobile breakpoint this collapses them, animates the slide, and
 * keeps only one group open at a time.
 */
(function () {
  var MOBILE = '(max-width: 749px)';
  var REDUCED = '(prefers-reduced-motion: reduce)';
  var DURATION = 300;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  var canAnimate = typeof Element !== 'undefined' && !!Element.prototype.animate;

  function groups(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.site-footer__acc'));
  }

  function panelOf(details) {
    return details.querySelector('.site-footer__acc-panel');
  }

  function cancel(details) {
    if (details.siteFooterAnim) {
      details.siteFooterAnim.onfinish = null;
      details.siteFooterAnim.cancel();
      details.siteFooterAnim = null;
    }
    if (details.siteFooterTimer) {
      clearTimeout(details.siteFooterTimer);
      details.siteFooterTimer = null;
    }
  }

  // Slide `details` to `want`. The panel is padded, and padding survives a height of
  // 0, so both are animated or the panel would never close all the way.
  function setOpen(details, want) {
    var panel = panelOf(details);
    if (!panel) {
      details.open = want;
      return;
    }

    var from = details.open ? panel.getBoundingClientRect().height : 0;
    cancel(details);

    if (!canAnimate || window.matchMedia(REDUCED).matches) {
      details.open = want;
      panel.style.overflow = '';
      return;
    }

    details.open = true; // must be rendered to measure and to animate
    var padding = window.getComputedStyle(panel).paddingTop;
    var to = want ? panel.scrollHeight : 0;

    function settle() {
      details.open = want;
      panel.style.overflow = '';
      cancel(details);
    }

    panel.style.overflow = 'hidden';
    details.siteFooterAnim = panel.animate(
      [
        { height: from + 'px', paddingTop: want ? '0px' : padding },
        { height: to + 'px', paddingTop: want ? padding : '0px' },
      ],
      { duration: DURATION, easing: EASING, fill: want ? 'none' : 'forwards' }
    );
    details.siteFooterAnim.onfinish = settle;

    // A throttled or frozen timeline can leave the animation parked on its first
    // keyframe, which would strand the panel at zero height. Land the state anyway.
    details.siteFooterTimer = setTimeout(settle, DURATION + 120);
  }

  function onSummaryClick(event) {
    var details = event.currentTarget.parentNode;
    if (!details || !details.classList.contains('site-footer__acc')) return;

    // A linked heading navigates instead of toggling. It is only clickable above the
    // breakpoint — CSS makes it inert on mobile, where the summary is the toggle.
    if (event.target.closest && event.target.closest('a[href]')) return;

    // We drive the state ourselves so the change can be animated.
    event.preventDefault();

    // Above the breakpoint every group is open and the summary is inert.
    if (!window.matchMedia(MOBILE).matches) return;

    var want = !details.open;
    var root = details.closest('.site-footer-main');

    if (want && root) {
      groups(root).forEach(function (other) {
        if (other !== details && other.open) setOpen(other, false);
      });
    }

    setOpen(details, want);
  }

  function syncToBreakpoint(root, isMobile) {
    groups(root).forEach(function (details) {
      cancel(details);
      var panel = panelOf(details);
      if (panel) panel.style.overflow = '';
      details.open = !isMobile;
    });
  }

  function init(root) {
    var mq = window.matchMedia(MOBILE);
    syncToBreakpoint(root, mq.matches);

    groups(root).forEach(function (details) {
      var summary = details.querySelector('.site-footer__acc-head');
      if (summary) summary.addEventListener('click', onSummaryClick);
    });

    var onChange = function (event) {
      syncToBreakpoint(root, event.matches);
    };

    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  init(document);

  // Re-run for the section the theme editor just re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.site-footer__acc')) {
      init(event.target);
    }
  });
})();
